import React, { useState, useEffect, useRef } from "react";
import { toast } from 'react-toastify';
import { useCart } from "../Context/Createcontext";
import { useParams } from "react-router-dom";
import axios from "axios";
import { useNavigate,useLocation } from 'react-router-dom';
import { Link } from "react-router-dom";
import leftarrow from '../images/left.png';
import rightarrow from '../images/right.png';
import { Helmet } from "react-helmet";
import Popup from '../Components/common/Popup'
import { api_url } from "../config/config";
import cart from '../images/cart.svg';
import addToCartIcon from '../Icons/addToCartIcon.svg';
import wish from '../images/wish.svg';
import wishlist from '../images/wishlist_nofill.svg';
import { useWishlist } from '../Context/WishlistContext';
import loader from "../images/loaderimg.png";

const ProductCard = () => {
  const navigate = useNavigate();
  const productSectionRef = useRef(null);
  const [productId, setProductId] = useState(null);
  const [variantId, setVariantId] = useState(null);
  const [updatecount, setUpdatecount] = useState([]);
  const { handleAddToCart, existingWishlistItem, showLoginPopup, setShowLoginPopup, cartItems, setCartItems,handleRemoveFromCart } = useCart();
  const { wishlist: wishlistItems, addToWishlist, removeFromWishlist, loading: wishlistLoading } = useWishlist();
  const [catid, setCatid] = useState([]);
  const [alternativeProducts, setAlternativeProducts] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentFeatured, setCurrentFeatured] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [manufacturers, setManufacturers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [viewAllAlter, setViewAllAlter] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [storedConcernId, setStoredConcernId] = useState([]);
  const [refresh, setRefresh] = useState(0);
  const [selectedQuantity, setSelectedQuantity] = useState(1);
  const [currentUser, setCurrentUser] = useState(null);
  const [product, setProduct] = useState([]);
  const [currentIndexs, setCurrentIndexs] = useState(0);
  const [isLoadingData, setIsLoadingData] = useState(true);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const discountedPrice = product.price - (product.price * product.discount_percent) / 100;
  const [selectedSize, setSelectedSize] = useState(null);
  const [selectedVariant, setSelectedVariant] = useState(null);
  const [allImages, setAllImages] = useState([]);
  const currentVariantId = selectedVariant?.variant_id ?? product?.variant?.[0]?.variant_id;
  const isWishlisted = currentVariantId ? (wishlistItems || []).some(w => w.product_id === product?.product_id && w.variant_id === currentVariantId) : false;
  const totalFeatured = viewAllAlter.length;

  const imagesPerPage = 5;
  const startFeatured = currentIndex * 5; 
  const visibleFeatured = viewAllAlter.slice(startFeatured, startFeatured + 5);
  const prevStoredConcernId = useRef(null);
  const prevCatid = useRef(null);
  const isToken = localStorage.getItem("authToken");
    const location = useLocation();
   const { product_id } = location?.state || {};


  useEffect(() => {
    if (product?.product_images?.image_url) {
      const primary = product.product_images.image_url.primary_image; // ✅ Corrected access
      const additional = product.product_images.image_url.additional_images || []; // ✅ Corrected access
      setAllImages([primary, ...additional]);
    }
  }, [product]);

  const nextFeatured = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % Math.ceil(alternativeProducts.length / imagesPerPage));
  };

  const prevFeatured = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + Math.ceil(alternativeProducts.length / imagesPerPage)) % Math.ceil(alternativeProducts.length / imagesPerPage));
  };


  // Thumbnail click handler
  const handleThumbnailClick = (index) => {
    setCurrentIndexs(index);
  };

  useEffect(() => {
    window.scrollTo(0, 0); 
  }, []);


  useEffect(() => {
    if (cartItems.length > 0) {
      const updatedQuantities = cartItems.reduce((acc, item) => {
        acc[item.variant_id] = item.quantity;
        return acc;
      }, {});

      console.log("🛠️ Updated Quantities Before SetState:", updatedQuantities);
      setUpdatecount(updatedQuantities);
    }
  }, [cartItems]); 


  const productdata = product_id;

  useEffect(() => {
    const productdata = product_id
    const storedVariantId = localStorage.getItem("variant_id");

    console.log("✅ Retrieving Product & Variant ID:", {
      productdata,
      storedVariantId,
    });

    setProductId(productdata);
    setVariantId(storedVariantId);
  }, []);


  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("currentUser"));
    setCurrentUser(user);
  }, []);

  const fetchManufacturers = (page) => {
    setIsLoading(true);
    axios
      .get(`${api_url}/manufacturer?page=${page}&limit=10`, {
        headers: {
          "Content-Type": "application/json",
             Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          
        },
      })
      .then((response) => {
        if (response.data && response.data.results) {
          setManufacturers(response.data.results);
          setTotalPages(Math.ceil(response.data.total / 10));
        } else {
          console.error('No manufacturers found in the response');
        }
        console.log('Manufacturersfeaturepage:', response.data.results);
      })
      .catch((err) => {
        console.error('Error fetching manufacturers:', err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    fetchManufacturers(currentPage);
  }, [currentPage]);


  const handleclickforfeaturedproduct = (product_id,product) => {
     navigate(`/products/${product.name?.toLowerCase().replace(/\s+/g, '-')}`, {
            state: { product_id },
     });

    if (productSectionRef.current) {
      productSectionRef.current.scrollIntoView({ behavior: "smooth", block: "start" });

      setTimeout(() => {
        window.scrollBy(0, -300);
      }, 500);
    }
  };




  const romanToInt = (roman) => {
    const romanMap = { I: 1, V: 5, X: 10, L: 50, C: 100, D: 500, M: 1000 };
    let num = 0;

    for (let i = 0; i < roman.length; i++) {
      let current = romanMap[roman[i]];
      let next = romanMap[roman[i + 1]];

      if (next && current < next) {
        num -= current;
      } else {
        num += current;
      }
    }
    return num;
  };

  const getNumericValue = (packSize) => {
    // Check if the packSize is a Roman numeral (string containing only Roman numeral characters)
    const isRoman = /^[IVXLCDM]+$/.test(packSize);

    if (isRoman) {
      return romanToInt(packSize); // Convert Roman numeral to integer
    }

    const match = packSize.match(/^\d+(\.\d+)?/); // Extract numbers if present
    if (match) return parseFloat(match[0]);

    return null;
  };

  const sortedVariants = [...(product.variant || [])].sort((a, b) => {
    const packSizeA = getNumericValue(a.pack_size);
    const packSizeB = getNumericValue(b.pack_size);

    if (packSizeA !== null && packSizeB !== null) {
      return packSizeA - packSizeB; // Sort by numeric values
    } else if (packSizeA !== null) {
      return -1;
    } else if (packSizeB !== null) {
      return 1;
    } else {
      return a.pack_size.localeCompare(b.pack_size); // Alphabetical order for non-numeric
    }
  });
  useEffect(() => {
    if (sortedVariants.length > 0 && !selectedSize) {
      const defaultVariant = sortedVariants.reduce((min, variant) => variant.price < min.price ? variant : min);
      setSelectedSize(defaultVariant.pack_size);
      setSelectedVariant(defaultVariant);
    }
  }, [sortedVariants, selectedSize]);




  

  // alternative function 

  const getAlternativeProducts = async (productCode) => {
    try {
      console.log("Fetching alternatives for product code:", productCode);
      const response = await axios.get(`${api_url}/api/alternative/${productCode}`, {
        headers: {
          "Content-Type": "application/json",
          'Authorization': 'Bearer ' + localStorage.getItem('authToken'),
          "x-auth": false
        },
      });

      console.log("Full Alternative API Response:", response.data);

      if (response.data && Array.isArray(response.data.data) && response.data.data.length > 0) {
        let alternativeProducts = response.data.data.map(item => item.product);

        // Remove duplicate products based on product_id
        const uniqueProducts = [...new Map(alternativeProducts.map(item => [item.product_id, item])).values()];

        console.log("Unique Alternative Products:", uniqueProducts);
        return uniqueProducts;
      } else {
        console.error("No alternatives found in response");
        return [];
      }
    } catch (error) {
      console.error('Error fetching alternative products:', error);
      return [];
    }
  };



  useEffect(() => {
    const fetchProductDetails = async () => {
      try {
        const response = await fetch(`${api_url}/product/${product_id}`, {
          headers: {
            "Content-Type": "application/json",
            'Authorization': 'Bearer ' + localStorage.getItem('authToken'),
            "x-auth": false
          },
        });

        if (!response.ok) {
          throw new Error("Failed to fetch product details");
        }

        const data = await response.json();
        console.log("Product details:", data.data);

        if (!data.data || !data.data.product_code) {
          console.error("Error: Product code not found in API response");
          return;
        }

        setProduct(data.data);

        // Fetch alternative products using product code from fetched product
        const alternatives = await getAlternativeProducts(data.data.product_code);
    

        if (alternatives && Array.isArray(alternatives)) {
          setAlternativeProducts(alternatives);
        } else {
          console.error("Unexpected alternative products response:", alternatives);
        }
      } catch (err) {
        console.error("Error fetching product details:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    if (productdata) {
      fetchProductDetails();
    }
  }, [productdata]);

  const nextImage = () => {
    if (currentIndexs < allImages.length - 1) {
      setCurrentIndexs(currentIndexs + 1);
    }
  };

  const prevImage = () => {
    if (currentIndexs > 0) {
      setCurrentIndexs(currentIndexs - 1);
    }
  };

  console.log("cartitem", cartItems)



  useEffect(() => {
    try {
      const concernRaw = localStorage.getItem("concern_id");
      const categoryRaw = localStorage.getItem("category_id");

      // ✅ Handle Single String (Convert to Array)
      let concernData = [];
      let categoryData = [];

      if (concernRaw) {
        concernData = concernRaw.startsWith("[") ? JSON.parse(concernRaw) : [concernRaw];
      }

      if (categoryRaw) {
        categoryData = categoryRaw.startsWith("[") ? JSON.parse(categoryRaw) : [categoryRaw];
      }

      console.log("Parsed Concern ID:", concernData);
      console.log("Parsed Category ID:", categoryData);

      setStoredConcernId(concernData);
      setCatid(categoryData);
    } catch (error) {
      console.error("Invalid JSON in localStorage, resetting values...");
      localStorage.setItem("concern_id", JSON.stringify([]));
      localStorage.setItem("category_id", JSON.stringify([]));
    }
  }, []);


  // Scroll Handlers for Similar Products
  useEffect(() => {
    if (alternativeProducts.length > 0) {
      const start = currentIndex * imagesPerPage;
      const end = start + imagesPerPage;
      setCurrentFeatured(alternativeProducts.slice(start, end));
    }
  }, [currentIndex, alternativeProducts]);

  const fetchCart = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${api_url}/cart`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      });

      const data = await response.json();
      console.log("cartdata", data.data.cartproduct);

      if (response.ok) {
        const formattedProducts = data.data.cartproduct.map((item) => ({
          product_id: item.product_id,
          variant_id: item.variant_id,
          quantity: item.quantity,
        }));

        setCartItems(formattedProducts);

        let updatedQuantities = {};
        formattedProducts.forEach((item) => {
          updatedQuantities[item.variant_id] = item.quantity;
        });

        // ✅ Only update if different
        setUpdatecount((prev) => {
          const hasChanged = Object.keys(updatedQuantities).some(
            (key) => prev[key] !== updatedQuantities[key]
          );

          if (hasChanged) {
            console.log("✅ Updating Quantities in State:", updatedQuantities);
            return { ...prev, ...updatedQuantities };
          } else {
            console.log("⚠️ Skipping update, values are the same.");
            return prev;
          }
        })
      } else {
        setError(data.message || "Failed to fetch cart.");
      }
    } catch (err) {
      setError(err.message || "An unexpected error occurred.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCart();
  }, []);

  const updateProductcount = async () => {
    let storedVariantId = variantId || localStorage.getItem("variant_id");

    if (!storedVariantId) {
      console.error("🚨 No Variant ID found!");
      return;
    }

    const requestBody = { variant_id: storedVariantId };

    console.log("📢 Sending API Request:", requestBody);

    try {
      const response = await axios.post(
        `${api_url}/cart/aProduct`,
        requestBody,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );
      if (response.data && response.data.data) {
        setUpdatecount((prev) => ({
          ...prev,
          [response.data.data.variant_id]: response.data.data.quantity, // ✅ Correct format
        }));
        console.log("✅ Cart Updated:", response.data.data.quantity);
      } else {
        console.error("❌ Failed to update cart.");
      }

    } catch (error) {
      console.error("❌ Error adding product to cart:", error);
      if (error.response) {
        console.error("📢 API Error Response:", error.response);
      } else {
        console.error("📢 Unknown Error:", error.message);
      }
    }
  };

  useEffect(() => {

  }, [updatecount]); // ✅ UI update hone ke baad log karein


  const handleQuantityChange = async (productId, variant_id, quantity, productName, operation) => {
    console.log("🔹 handleQuantityChange Called with:", { productId, variant_id, quantity });

    if (!productId || !variant_id || typeof quantity !== "number") {
      console.error("❌ Missing or invalid required fields:", { productId, variant_id, quantity });
      return;
    }

    try {
      const response = await fetch(`${api_url}/product/${productId}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      });

      const productData = await response.json();
      console.log("productdata", productData.data.name);

      let selectedVariant = productData.data.variant.find((v) => v.variant_id === variant_id);
      if (!selectedVariant) {
        console.error("❌ Variant not found for", productName);
        toast.error(`Variant not found for ${productName}`);
        return;
      }

      let currentStock = selectedVariant.quantity;
      console.log(`🔍 ${productData.data.name} Current Stock:`, currentStock);


      let newQuantity = operation === "increase" ? quantity + 1 : quantity - 1;


      // ✅ Send correct newQuantity to API
      const cartResponse = await fetch(`${api_url}/cart`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
        body: JSON.stringify({
          product_id: productId,
          quantity: quantity,  // ✅ Corrected this line
          variant_id,
        }),
      });

      const responseData = await cartResponse.json();

      if (!cartResponse.ok || responseData.message?.toLowerCase().includes("stock not available")) {
        toast.error(`${productData.data.name} is out of stock`);
        return;
      }



      // ✅ Update state correctly
      setUpdatecount((prev) => ({
        ...prev,
        [variant_id]: newQuantity,
      }));

      return true;
    } catch (error) {
      console.error("❌ Error updating cart quantity:", error);
    }
  };



  useEffect(() => {
    setTimeout(() => updateProductcount(), 500); // ⏳ Ensure `variantId` is set before API call
  }, [cartItems]);



  const handleIncrease = async (event, variant) => {
    event.preventDefault();

    if (!variant || !variant.variant_id) {
      console.error("❌ Invalid variant data in handleIncrease");
      return;
    }

    console.log("🔼 Increasing quantity for:", variant);

    let newQuantity = (updatecount[variant.variant_id] || 0) + 1;

    // ✅ API Call First, then update UI
    const success = await handleQuantityChange(variant.product_id, variant.variant_id, newQuantity, variant.name, "increase");

    if (success) {
      setUpdatecount((prev) => ({
        ...prev,
        [variant.variant_id]: newQuantity,
      }));
    }
  };

   const getCartQuantity = (variantId) => {
    
        const item = cartItems.find(ci => ci.variant_id === variantId);
        return item ? item.quantity : 0;
    };

                  const handleIncreaseForTrendingProduct = async (event, variant,item) => {
                    event.preventDefault();
                    try{
                    if (!variant || !variant.variant_id) {
                      console.error("❌ Invalid variant data in handleIncrease");
                      return;
                    }
                    const quantity = await getCartQuantity(variant.variant_id);
                  
                      const cartResponse = await fetch(`${api_url}/cart`, {
                        method: "PATCH",
                        headers: {
                          "Content-Type": "application/json",
                          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
                        },
                        body: JSON.stringify({
                          product_id: variant.product_id,
                          quantity: quantity+1,  
                          variant_id: variant.variant_id,
                        }),
                      });
            
                     const responseData = await cartResponse.json();
                     console.log("Response Data:", responseData);
                     if (!cartResponse.ok || responseData.message?.toLowerCase().includes("stock not available")) {
                       toast.error(`${item.name} is out of stock`);
                       return;
                     }
                     const newCart = cartItems.map(item =>
                      item.variant_id === variant.variant_id
                        ? { ...item, quantity: item.quantity + 1 }
                        : item
                    );
                    setCartItems(newCart);
                    }
                    catch(err){
                      console.log(err);
                      toast.error(`Something went wrong`);
                    }
                  };
            
            
                  const handleDecreaseForTrendingProduct = async (event, variant) => {
                    event.preventDefault();
                    try{
                    if (!variant || !variant.variant_id) {
                      return;
                    }
                     const quantity = await getCartQuantity(variant.variant_id);
                      if(quantity === 1){
                        handleRemoveFromCart(variant.product_id, variant.variant_id);
                        // const responseData = await cartResponse.json();
                        // console.log("Response Data: decrease", responseData);
                        // if (!cartResponse.ok || responseData.message?.toLowerCase().includes("stock not available")) {
                        //   toast.error(`Something went wrong`);
                        //   return;
                        // }
                        // await fetchCart();
                        return
                      }
                      const cartResponse = await fetch(`${api_url}/cart`, {
                            method: "PATCH",
                            headers: {
                              "Content-Type": "application/json",
                              Authorization: `Bearer ${localStorage.getItem("authToken")}`,
                            },
                            body: JSON.stringify({
                              product_id: variant.product_id,
                              quantity:quantity - 1,  // ✅ Corrected this line
                              variant_id: variant.variant_id,
                            }),
                          });
            
                        const responseData = await cartResponse.json();
                  
                  
                        if (!cartResponse.ok || responseData.message?.toLowerCase().includes("stock not available")) {
                          toast.error(`Something went wrong`);
                          return;
                        }
                       const newCart = cartItems.map(item =>
                          item.variant_id === variant.variant_id
                            ? { ...item, quantity: item.quantity - 1 }
                            : item
                        );
                        setCartItems(newCart);
                      }catch(err){
                        console.log(err);
                        toast.error(`Something went wrong`);
                      }
                  };

              const handleDecrease = async (event, variant) => {
                event.preventDefault();

                if (!variant || !variant.variant_id) {
                  return;
                }

                const currentQty = updatecount[variant.variant_id];

                if (currentQty === 1) {
                  const success = await handleRemoveFromCart(variant.product_id, variant.variant_id);
                  console.log("Remove from cart success:", success);
                    setUpdatecount((prev) => {
                      const updated = { ...prev };
                      delete updated[variant.variant_id];
                      return updated;
                    });
                  return; 
                }

                let newQuantity = currentQty - 1;

                const success = await handleQuantityChange(
                  variant.product_id,
                  variant.variant_id,
                  newQuantity,
                  variant.name,
                  "decrease"
                );

                if (success) {
                  setUpdatecount((prev) => ({
                    ...prev,
                    [variant.variant_id]: newQuantity,
                  }));
                }
              };


  const OutOfQuantityCheck = (variants) => {
    if (!Array.isArray(variants) || variants.length === 0) return true;
    const result = variants.every((v) => v.quantity === 0);
    console.log('Checking variants:', variants, 'Result:', result);
    return result;
  };


  return (
    <div>
      <Helmet>
        <title>
          {product?.name
            ? `${product.name} | Online Medical Store, Online Medicine Order, Fastest Delivery | MediSYS Pharmacy`
            : "Online Medical Store | MediSYS Pharmacy"}
        </title>
        <meta
          name="description"
          content="MediSYS Pharmacy Online Medical Store - Online Medicine Order - Buy medicines online from MediSYS Pharmacy Store and experience the fastest home delivery. All kinds of medicines, health products, and equipment are available at our online medicine store."
        />
        <meta
          name="keywords"
          content="pharmacy, medical stores, online pharmacy, online pharmacy India, best online pharmacy, online pharmacy hyderabad, online medical store, online medicine store, online medical shop, online medical store hyderabad"
        />
        <meta name="robots" content="index, follow" />
        <meta
          property="og:title"
          content="Online Medical Store, Online Medicine Order, Fastest Delivery | MediSYS Pharmacy"
        />
        <meta
          property="og:description"
          content="MediSYS Pharmacy Online Medical Store - Online Medicine Order - Buy medicines online from MediSYS Pharmacy Store and experience the fastest home delivery. All kinds of medicines, health products, and equipment are available at our online medicine store."
        />
      </Helmet>

      <section className="px-4 py-6 mt-20 overflow-hidden">
        <div className="max-w-6xl mx-auto bg-white space-y-4 mt-8">
          <ul className="flex items-center list-none p-0 m-0 flex-wrap space-x-2 sm:space-x-4">
            <li className="text-sm lg:text-xl font-semibold font-poppins text-[#1a1a1a] sm:text-base">
              <Link to="/home">Home</Link>
            </li>
            <li className="text-sm lg:text-xl font-semibold font-poppins text-[#1a1a1a] sm:text-base">
              &gt;
            </li>
            <li className="text-sm lg:text-xl font-poppins font-semibold text-[#1a1a1a] sm:text-base">
              <Link to='/products'>All Products</Link>
            </li>
            <li className="text-sm lg:text-xl font-poppins font-semibold text-[#1a1a1a] sm:text-base">
              &gt;
            </li>
            <li className="text-sm lg:text-xl font-poppins font-semibold text-[#1a1a1a] sm:text-base">
              {product?.name}
            </li>
          </ul>

          
          <div ref={productSectionRef} className="flex flex-col lg:flex-row lg:mt-10 lg:ml-[10px] gap-8 justify-center items-center">
            <div className="flex flex-col items-center relative">     
              <div className="w-40 h-52 sm:w-48 sm:h-60 md:w-64 md:h-72 lg:w-80 lg:h-80 border border-gray-300 rounded-lg p-4 flex justify-center items-center relative"> 
                <div
                  className="absolute top-2 left-2 z-20"
                  onMouseEnter={() => setTooltipOpen(true)}
                  onMouseLeave={() => setTooltipOpen(false)}
                >
                  <button
                    className="focus:outline-none"
                    onClick={(e) => {
                      e.stopPropagation();
                      const token = localStorage.getItem('authToken');
                      if (!token) {
                        setShowLoginPopup(true);
                        return;
                      }
                      if (isWishlisted && currentVariantId) {
                        removeFromWishlist(product.product_id, currentVariantId);
                      } else {
                        const variantObj = (product?.variant || []).find(v => v.variant_id === currentVariantId) || selectedVariant;
                        if (variantObj) {
                          addToWishlist(product, variantObj);
                        } else {
                          toast.error('Variant not available');
                        }
                      }
                    }}
                    disabled={wishlistLoading}
                  >
                    <img
                      src={isWishlisted ? wish : wishlist}
                      alt={isWishlisted ? 'Remove from wishlist' : 'Add to wishlist'}
                      className="w-5 h-5 lg:w-6 lg:h-6 transition-all"
                    />
                  </button>
                  
                  <div
                    className={`absolute left-7 top-1 px-2 py-1 rounded bg-black text-white text-xs whitespace-nowrap shadow transition-opacity duration-200 ${tooltipOpen ? 'opacity-100 visible' : 'opacity-0 invisible'} z-30`}
                  >
                    {isWishlisted ? 'Remove from wishlist' : 'Add to wishlist'}
                  </div>
                </div>
        
                {product.discount_percent > 0 && (
                  <div className="absolute top-2 right-2 bg-red-500 text-white text-xs font-semibold w-10 h-10 flex items-center justify-center rounded-full z-10 text-center">
                    {product.discount_percent}% OFF
                  </div>
                )}

                <img
                  src={
                    allImages?.[currentIndexs] ||
                    product?.product_images?.image_url?.primary_image ||
                    "https://via.placeholder.com/150"
                  }
                  alt={product?.name || "Product Image"}
                  onError={(e) => { e.target.onerror = null; e.target.src = "/default.svg"; }}

                  className="max-w-full max-h-full object-contain transition-transform duration-300 hover:scale-105"
                />


                {allImages.length > 1 && (
                  <>
                    {/* Left Arrow */}
                    <button
                      onClick={prevImage}
                      disabled={currentIndexs <= 0}
                      className="absolute -ml-[50px] top-1/2 left-2 -translate-y-1/2 flex items-center bg-white bg-opacity-50 p-1 rounded-full"
                    >
                      <img src={leftarrow} alt="Previous" className="w-4 h-8" />
                    </button>

                    {/* Right Arrow */}
                    <button
                      onClick={nextImage}
                      disabled={currentIndexs >= allImages.length - 1}
                      className="absolute -mr-[50px] top-1/2 right-2 -translate-y-1/2 flex items-center bg-white bg-opacity-50 p-1 rounded-full"
                    >
                      <img src={rightarrow} alt="Next" className="w-4 h-8" />
                    </button>
                  </>
                )}
              </div>


              <div className={`flex gap-2 mt-4 w-full ${allImages.length > 3 ? "overflow-x-auto overflow-y-hidden" : "justify-center"}`}>
                <div className={`flex ${allImages.length > 3 ? "w-[90%]" : "w-auto"} space-x-2`}>
                  {allImages.map((img, index) => (
                    <img
                      key={index}
                      src={img || "https://via.placeholder.com/150"} 
                      alt={`Thumbnail ${index + 1}`}
                      className={`w-16 h-16 cursor-pointer border-2 rounded-lg object-cover transition-transform duration-300  ${index === currentIndexs ? "border-green-600" : "border-gray-300"
                        }`}
                      onClick={() => handleThumbnailClick(index)}
                      onError={(e) => { e.target.onerror = null; e.target.src = "/default.svg"; }}

                    />
                  ))}
                </div>
              </div>

            </div>


   
            <div className="flex flex-col gap-4 px-4 lg:px-10 text-left sm:mt-5">
          
              <h2 className="text-base  font-medium sm:text-2xl sm:font-semibold">{product?.name}</h2>
          
              <div className="text-sm sm:text-xl font-inter font-normal flex items-center gap-3 text-[#1A1A1A]">
                <p>MRP:</p>

                {product.variant?.length > 0 && (
                  <>
                    {(product.discount_percent > 0 && product.variant[0].discounted_price !== null) ? (
                      <>
                        <span className="text-xs text-gray-500 line-through">
                          ₹{selectedVariant ? selectedVariant.price : product.variant[0].price}
                        </span>
                        <span className="text-lg sm:text-xl font-inter ">
                          ₹{selectedVariant ? selectedVariant.discounted_price : product.variant[0].discounted_price}
                        </span>
                      </>
                    ) : (
                      // No discount, only show original price
                      <span className="text-lg sm:text-xl font-inter">
                        ₹{selectedVariant ? selectedVariant.price : product.variant[0].price}
                      </span>
                    )}
                  </>
                )}
                
              </div>
            
              {/* Pack Size Section */}
              {sortedVariants.length > 0 && sortedVariants.some(v => v.pack_size) &&  (
                <div>
                  <p className="text-sm sm:text-base font-poppins font-medium">Pack Size</p>
                  <div className="flex flex-wrap gap-2 mt-2">
                    {sortedVariants
                      .sort((a, b) => {

                        const priceA = a.price || 0;
                        const priceB = b.price || 0;
                        return priceA - priceB;
                      })
                      .map((variant, index) => (
                        <button
                          key={index}
                          onClick={() => {
                            setSelectedSize(variant.pack_size);
                            setSelectedVariant(variant);
                          }}
                          className={`border-2 rounded-lg px-4 py-1 text-sm ${selectedSize === variant.pack_size
                            ? "bg-green-100 border-green-700"
                            : "border-gray-300"
                            }`}
                        >
                          {variant.pack_size} 
                        </button>
                      ))}
                  </div>


                  {selectedSize === null && (
                    <div className="text-sm text-gray-500 mt-2">
                      Default selected size will be the smallest price pack.
                    </div>
                  )}
                </div>
              )}





<div className="h-5">
  {Array.isArray(product.variant) && OutOfQuantityCheck(product.variant) && (
    <div>
      <p className="text-xs text-red-500 font-semibold">Out of Stock</p>
    </div>
  )}
</div>


              {/* Manufacturer and Details */}
              <div className="text-sm font-medium space-y-2 lg:mt-[6px]">
                  
                {/* Manufacturer/Marketer */}
                {product?.manufacturer?.name && (
                  <p>
                    <span className="font-semibold">Manufacturer/Marketer </span> <br />
                    <span className="font-normal">{product.manufacturer?.name}</span>
                  </p>
                )}

                {/* Consume Type */}
                {product?.consume_type && (
                  <p>
                    <span className="font-semibold">Consume Type </span> <br />
                    <span className="font-normal">{product.consume_type}</span>
                  </p>
                )}

                {/* Return Policy */}
                {product?.return_policy && (
                  <p>
                    <span className="font-semibold">Return Policy </span> <br />
                    <span className="font-normal">{product.return_policy}</span>
                  </p>
                )}
              </div>


              <div className="flex flex-col sm:flex-row sm:items-start gap-4 w-full">
               
                <div className="flex flex-row items-center gap-2 sm:gap-4 w-full sm:w-auto">
             
                {updatecount[selectedVariant?.variant_id] ? (
                      <div className="flex items-center space-x-8 border-2 border-black rounded-xl py-1 px-1 w-40">
                        <button
                          className="px-3 py-1 text-xl text-black cursor-pointer"
                          onClick={(event) => handleDecrease(event, selectedVariant)}
                          type="button"
                        >
                          -
                        </button>

                        <span className="text-lg font-bold text-black">
                          {updatecount[selectedVariant?.variant_id]}
                        </span>

                        <button
                          className="px-3 py-1 text-xl text-black cursor-pointer"
                          onClick={(event) => handleIncrease(event, selectedVariant)}
                          type="button"
                        >
                          +
                        </button>
                      </div>
                    ) : (
                      <Link to="/cartpage" className="w-full sm:w-auto">
                        <button
                          className={`bg-[#162C2A] hover:bg-green-600 transition-all  disabled:hover:none disabled:bg-gray-500 w-40 text-[16px] font-[500] font-poppins text-white py-3 rounded-xl  flex items-center justify-center gap-2  ${loading ? "opacity-50 cursor-not-allowed" : ""}`}
                          onClick={(e) => {
                            e.preventDefault();
                            handleAddToCart(product, selectedVariant, selectedQuantity);
                          }}
                          disabled={OutOfQuantityCheck(product.variant)}
                        >
                          <img
                            src={addToCartIcon}
                            alt="Cart"
                            className="w-[15px] h-[18px] font-500 mr-3 object-contain"
                          />
                          {loading ? "Adding..." : "Add to Cart"}
                        </button>
                      </Link>
                    )}

                </div>

                {showLoginPopup && <Popup onClose={() => setShowLoginPopup(false)} />}


              </div>




            </div>
          </div>





          {/* Description Section (Below Images) */}
          <div className="mt-6 text-sm">
            {/* Description */}
            {product?.description && (
              <div>
                <p className="text-base sm:text-xl font-medium font-poppins mb-1 text-left lg:text-left">Description</p>
                <p className="lg:text-[14px] text-[12px] font-medium text-justify">{product.description}</p>
              </div>
            )}

            {/* How to Use */}
            {product?.how_to_use && (
              <div className="mt-4">
                <p className="text-base sm:text-xl font-medium font-poppins mb-1 text-left lg:text-left">How to Use</p>
                <p className="lg:text-[14px] text-[12px] font-medium text-justify">{product.how_to_use}</p>
              </div>
            )}

            {/* Benefits */}
            {product?.benefits && (
              <div className="mt-4">
                <p className="text-base sm:text-xl font-medium font-poppins mb-1 text-left lg:text-left">Benefits</p>
                <p className="lg:text-[14px] text-[12px] font-medium text-justify">{product.benefits}</p>
              </div>
            )}

            {/* Safety Advice */}
            {product?.safety_advise && (
              <div className="mt-4">
                <p className="text-base sm:text-xl font-medium font-poppins mb-1 text-left lg:text-left">Safety Advice</p>
                <p className="lg:text-[14px] text-[12px] font-medium text-justify">{product.safety_advise}</p>
              </div>
            )}
          </div>

        </div>
      </section>

      <br />

      {/* alternative products for desktop screens only */}
      {alternativeProducts.length > 0 && (
        <section className="hidden lg:flex w-full p-1 flex-col items-center">
          <h3 className="text-lg sm:text-xl font-semibold mb-4">Alternative Products</h3>
          <div className="flex items-center w-full sm:w-4/5">
            <div className="relative w-full flex flex-col items-center">
              {/* Product Container */}
              <div className="overflow-hidden w-[120%] flex justify-center px-5">
                <div className="flex gap-3 sm:gap-5 transition-transform duration-500 px-5">
                  {currentFeatured.map((item, index) => (
                  <div
                    key={index}
                    className="group flex flex-col items-center justify-center w-[120px] sm:w-[140px] md:w-[190px] h-[auto] text-center border border-gray-300 rounded-lg overflow-hidden bg-white transition-transform duration-300 transform hover:scale-105 shadow-md"
                    style={{ border: "0.74px solid #eaeaea", borderRadius: "10px", paddingBottom: '10px' }}
                  >
                    {/* Product Link */}
                    <Link
                      to="#"
                      onClick={(e) => {
                        e.preventDefault();
                        handleclickforfeaturedproduct(item.product_id, item);
                      }}
                      className="w-full"
                    >
                      {/* Product Image */}
                      <div className="relative w-full flex justify-center mt-2">
                        <img
                          src={
                            item?.product_images?.image_url?.primary_image ||
                            "https://via.placeholder.com/150"
                          }
                          alt={item.name || "Product Image"}
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = "/default.svg";
                          }}
                          className="w-[80px] h-[80px] sm:w-[120px] sm:h-[120px] md:w-[140px] md:h-[140px] rounded-lg transition-transform duration-300 group-hover:scale-110"
                        />

                        {/* Discount Badge */}
                        {item.discount_percent > 0 && (
                          <div className="absolute top-1 right-1 sm:-top-8 bg-red-500 text-white text-[10px] sm:text-xs font-semibold w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center rounded-full">
                            {item.discount_percent}% OFF
                          </div>
                        )}
                      </div>

                      {/* Product Name */}
                      <div className="w-full text-center mt-2 px-2 hover:px-2">
                        <div className="text-xs p-2 sm:text-sm font-semibold text-gray-900 truncate w-full">
                          {item.name || "No Name"}
                        </div>
                      </div>
                     <div className="text-sm font-semibold flex gap-3 text-[#1A1A1A] justify-center">
                        {item.discount_percent > 0 && (
                          <div className="text-xs text-gray-500 line-through mt-1">
                            ₹{item.variant[0]?.price}
                          </div>
                        )}
                        <div>
                          ₹{item.variant[0]?.discounted_price}
                        </div>
                      </div>
                    </Link>

                    {/* Cart Buttons */}
                    {getCartQuantity(item.variant[0]?.variant_id) > 0 ? (
                      <div className="flex items-center justify-between border-2 border-black rounded-xl lg:px-4 gap-2 sm:gap-5 px-4 mt-2">
                        <button
                          className="px-2 sm:px-3 py-1 text-lg sm:text-xl text-black cursor-pointer"
                          onClick={(event) => handleDecreaseForTrendingProduct(event, item.variant[0], item)}
                          type="button"
                        >
                          -
                        </button>
                        <span className="text-base sm:text-lg font-bold text-black min-w-[20px] text-center">
                          {getCartQuantity(item.variant[0]?.variant_id)}
                        </span>
                        <button
                          className="px-2 sm:px-3 py-1 text-lg sm:text-xl text-black cursor-pointer"
                          onClick={(event) => handleIncreaseForTrendingProduct(event, item.variant[0], item)}
                          type="button"
                        >
                          +
                        </button>
                      </div>
                    ) : (
                      <button
                        className="bg-[#162c2a] text-[11px] font-[300] md:text-[12px] md:font-[300] lg:text-[16px] lg:font-[500] font-poppins sm:text-base w-[90%] mt-2 h-10 text-white rounded-md hover:bg-[#1d3f3d] transition-all flex items-center justify-center gap-2"
                        onClick={async (event) => {
                          event.preventDefault();
                          event.stopPropagation();
                          await handleAddToCart(item, item.variant[0], 1);
                        }}
                      >
                        <img src={addToCartIcon} alt="Cart" className="w-[14px] h-[14px] lg:w-[15px] lg:h-[18px] font-500 lg:mr-3 object-contain" />
                        Add to Cart
                      </button>
                    )}
                  </div>

                  ))}
                </div>
              </div>

              {/* Navigation Arrows (Hidden on Mobile) */}
              <div
                className="hidden md:block absolute top-1/2 lg:-left-[5%] cursor-pointer transform -translate-y-1/2"
                onClick={prevFeatured}
              >
                <svg width="16" height="32" viewBox="0 0 16 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M14 30L4.24264 20.2426C1.89949 17.8995 1.89949 14.1005 4.24264 11.7574L14 2"
                    stroke="#7B7B7B"
                    strokeWidth="3"
                  />
                </svg>
              </div>

              <div
                className="hidden md:block absolute top-1/2 lg:-right-[5%] cursor-pointer transform -translate-y-1/2"
                onClick={nextFeatured}
              >
                <svg width="16" height="32" viewBox="0 0 16 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M2 2L11.7574 11.7574C14.1005 14.1005 14.1005 17.8995 11.7574 20.2426L2 30"
                    stroke="#7B7B7B"
                    strokeWidth="3"
                  />
                </svg>
              </div>
            </div>
          </div>
        </section>
      )}


      {/* alternative products for mobile and tablet screens */}

      {alternativeProducts.length > 0 && (
        <section className="lg:hidden w-full p-4 flex flex-col items-center">
          <h3 className="text-lg sm:text-xl font-semibold mb-4">Alternative Products</h3>
          <div className="flex items-center w-full sm:w-4/5 overflow-x-auto custom-scrollbar">
            <div className="relative w-full flex flex-col items-center">
              <div className="overflow-x-auto w-full flex justify-start scrollbar-hide">
                <div className="flex gap-3 sm:gap-5 transition-transform duration-500">
                  {alternativeProducts.map((item, index) => (
                    <div
                      key={index}
                      className="group flex flex-col items-center justify-center w-[120px] sm:w-[140px] md:w-[190px] min-h-[230px] sm:min-h-[260px] text-center border border-gray-300 rounded-lg overflow-hidden bg-white transition-transform duration-300 transform hover:scale-105 shadow-md"
                      style={{ border: "0.74px solid #eaeaea", borderRadius: "10px" }}
                    >
                      {/* Clickable Area (Image + Name) */}
                      <Link
                        to="#"
                        onClick={(e) => {
                          e.preventDefault();
                          handleclickforfeaturedproduct(item.product_id, item);
                        }}
                        className="w-full"
                      >
                        {/* Product Image */}
                        <div className="relative w-full flex justify-center mt-2">
                          <img
                            src={
                              item?.product_images?.image_url?.primary_image ||
                              "https://via.placeholder.com/150"
                            }
                            alt={item.name || "Product Image"}
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = "/default.svg";
                            }}
                            className="w-[80px] h-[80px] sm:w-[120px] sm:h-[120px] md:w-[140px] md:h-[140px] rounded-lg transition-transform duration-300 group-hover:scale-110"
                          />

                          {/* Discount Badge */}
                          {item.discount_percent > 0 && (
                            <div className="absolute -top-6 right-1 sm:-top-8 bg-red-500 text-white text-[10px] sm:text-xs font-semibold w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center rounded-full">
                              {item.discount_percent}% OFF
                            </div>
                          )}
                        </div>

                        {/* Product Name */}
                        <div className="w-full text-center mt-2 px-2">
                          <div className="text-xs p-2 sm:text-sm font-semibold text-gray-900 truncate w-full">
                            {item.name || "No Name"}
                          </div>
                        </div>
                      <div className="text-sm font-semibold flex gap-3 text-[#1A1A1A] justify-center">
                        {item.discount_percent > 0 && (
                          <div className="text-xs text-gray-500 line-through mt-1">
                            ₹{item.variant[0]?.price}
                          </div>
                        )}
                        <div>
                          ₹{item.variant[0]?.discounted_price}
                        </div>
                      </div>
                      </Link>

                      {/* Cart Controls */}
                      {getCartQuantity(item.variant[0]?.variant_id) > 0 ? (
                        <div className="flex items-center justify-between border-2 border-black rounded-xl lg:px-4 gap-2 sm:gap-5 mx-2 mt-2 w-[90%]">
                          <button
                            className="px-2 sm:px-3 py-1 text-lg sm:text-xl text-black cursor-pointer"
                            onClick={(event) => handleDecreaseForTrendingProduct(event, item.variant[0], item)}
                            type="button"
                          >
                            -
                          </button>
                          <span className="text-base sm:text-lg font-bold text-black min-w-[20px] text-center">
                            {getCartQuantity(item.variant[0]?.variant_id)}
                          </span>
                          <button
                            className="px-2 sm:px-3 py-1 text-lg sm:text-xl text-black cursor-pointer"
                            onClick={(event) => handleIncreaseForTrendingProduct(event, item.variant[0], item)}
                            type="button"
                          >
                            +
                          </button>
                        </div>
                      ) : (
                        <button
                          className="bg-[#162c2a] text-[11px] font-[300] md:text-[12px] md:font-[300] lg:text-[16px] lg:font-[500] font-poppins sm:text-base w-[90%] mt-2 h-10 text-white rounded-md hover:bg-[#1d3f3d] transition-all mx-2 flex items-center justify-center gap-2"
                          onClick={async (event) => {
                            event.preventDefault();
                            event.stopPropagation();
                            await handleAddToCart(item, item.variant[0], 1);
                          }}
                        >
                          <img
                            src={addToCartIcon}
                            alt="Cart"
                            className="w-[14px] h-[14px] lg:w-[15px] lg:h-[18px] font-500 lg:mr-3 object-contain"
                          />
                          Add to Cart
                        </button>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>
      )}





    </div>
  );
};

export default ProductCard;



